import { Progress, Typography, Upload } from "antd";
import { CloudUploadOutlined, DownloadOutlined } from "@ant-design/icons";
import { useTheme } from "../../../contexts/ThemeContext";
import { Button } from "../../ui";
import { MAX_FILE_MB } from "./additionalInfoUtils";

const { Text } = Typography;

/** Baixar o modelo e soltar o arquivo preenchido. Sem edição, só o download. */
const UploadArea = ({ canEdit, downloading, uploading, uploadPercent, disabled, onDownload, beforeUpload }) => {
  const { theme } = useTheme();

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      <Button
        icon={<DownloadOutlined />}
        loading={downloading}
        disabled={downloading}
        onClick={onDownload}
        style={{ alignSelf: "flex-start", borderRadius: 8 }}
      >
        Baixar modelo
      </Button>

      {canEdit ? (
        <Upload.Dragger
          name="file"
          accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          showUploadList={false}
          multiple={false}
          disabled={disabled || uploading}
          beforeUpload={beforeUpload}
          style={{ borderRadius: 12, background: theme.background, borderColor: theme.border }}
        >
          <div style={{ padding: "6px 12px", display: "flex", alignItems: "center", gap: 12, textAlign: "left" }}>
            <CloudUploadOutlined style={{ fontSize: 24, color: theme.textSecondary }} />
            <div style={{ minWidth: 0, flex: 1 }}>
              {uploading ? (
                <>
                  <Text style={{ display: "block", fontSize: 13, color: theme.textPrimary }}>Enviando planilha…</Text>
                  <Progress percent={uploadPercent} size="small" showInfo={false} style={{ margin: "4px 0 0" }} />
                </>
              ) : (
                <>
                  <Text style={{ display: "block", fontSize: 13, color: theme.textPrimary }}>
                    Arraste a planilha preenchida ou <span style={{ color: theme.primary }}>clique para enviar</span>
                  </Text>
                  <Text style={{ fontSize: 12, color: theme.textSecondary }}>{`.xlsx até ${MAX_FILE_MB} MB`}</Text>
                </>
              )}
            </div>
          </div>
        </Upload.Dragger>
      ) : (
        <Text style={{ fontSize: 13, color: theme.textSecondary }}>
          Você tem acesso somente leitura: pode baixar o modelo e consultar os lançamentos.
        </Text>
      )}
    </div>
  );
};

export default UploadArea;
